var render, staticRenderFns
import script from "./teleport.vue?vue&type=script&lang=js&"
export * from "./teleport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c6bba2')) {
      api.createRecord('b4c6bba2', component.options)
    } else {
      api.reload('b4c6bba2', component.options)
    }
    
  }
}
component.options.__file = "src/components/teleport/teleport.vue"
export default component.exports